module.exports = __webpack_public_path__ + "media/images/no-data-246a37fa85124956ff6ab435f7e1dc4d.png";